module.exports = __webpack_public_path__ + "static/media/17.3f11b4b0.png";